import fieldsSlices from './fields';
import seasonsSlices from './seasons';

const gffSlices = [fieldsSlices, seasonsSlices];

export default gffSlices;
